/* The K mark, drawn inline so it inherits the design tokens and stays crisp at
   nav size.

   The supplied artwork was a 1536x1024 PNG with a soft dark glow baked in and
   no fully-opaque pixels — as a raster it would have shown grey fringing on a
   light background and gone soft at any size. The mark is straight-edged
   geometry, so it was traced back to a real vector instead: 18 points, matching
   the source at IoU 0.995. See scripts/vectorize_logo.py.

   Note the viewBox is 1000x900, not square. `w-auto` is load-bearing — giving
   this a matching width and height would squash it. */
export const Logo = ({ className = "", showWordmark = true }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <svg
      viewBox="0 0 1000 900"
      aria-hidden="true"
      focusable="false"
      className="h-7 w-auto shrink-0 text-gold"
    >
      <path fill="currentColor" d="M0,899 L66,899 L492,481 L995,0 L638,0 L41,596 L37,596 L36,591 L92,513 L285,273 L285,1 L0,0 Z M399,649 L400,653 L648,899 L653,900 L1000,899 L582,465 Z" />
    </svg>
    {showWordmark && (
      <span
        translate="no"
        className="font-display text-h3 uppercase text-bone"
      >
        Kyrosity
      </span>
    )}
  </span>
);

export default Logo;
